import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({ name: "SkeletonLoader" })
export default class SkeletonLoader extends Vue {
    public loadIndexItems: number;
    public contentIndexItems: number;

    @Prop() readonly template: string;
    @Prop() readonly rowcards: number;
    @Prop() readonly loadIndex: number;
    @Prop() readonly contentIndex: number;
    
    public async created() {
        this.loadIndexItems = !this.loadIndex ? 1 : this.loadIndex;
        this.contentIndexItems = !this.contentIndex ? 1 : this.contentIndex;
    }
};